<template>
    <div>
        <v-btn class="blue__v-btn mb-2" @click="$router.go(-1)">Назад</v-btn>
        <div class="flex-column">
            <p class="formul-text-table">{{ nameOrgForRegion }}</p>
            <p class="little-text">{{ defaultText }}</p>
        </div>
        <v-row dense>
            <v-col class="header-columns mr-11" cols="5">
                Показатели
            </v-col>
            <v-col class="header-columns" cols="5">
                Балльная оценка
            </v-col>
            <v-col></v-col>
        </v-row>
        <template v-if="!loading">
            <card-indicator
                    :item="{
                      title: 'Сводная оценка заявки',
                      about: 'Сумма баллов по всем показателям',
                      count: middleValue,
                      dataFieldName: 'generalValue',
                      max: indicators.iowgt,
                      maxGradient: indicators.iowgt,
                      available: true,
                      typeStyle: 'general',
                      idUsl: idUsl
                    }"
                    :row-of-values="indicators"
                    @appeal-indicator="openAppeal($event)"
            />
            <card-indicator
                    v-for="(b, index) in bIndicatorsCalculated"
                    :key="index"
                    :item="b"
                    :loading="getIndicatorsStatus"
                    :row-of-values="indicator"
                    @appeal-indicator="openAppeal($event)"
            />
        </template>
        <template v-else>
            <div class="d-flex flex-row align-center justify-center" style="min-height: 200px;">
                <v-progress-linear indeterminate/>
            </div>
        </template>
        <!--    <p class="mt-5 mb-7">-->
        <!--      В публикации дробные значения показателей и аргументов расчета округлены. В действительности все вычисления проводятся с точностью до седьмого знака после запятой.-->
        <!--    </p>-->
        <!--    <ul class="pl-2 mt-10">-->
        <!--      Механизм подачи апелляций:-->
        <!--      <li>- апелляцию на ошибку в исходных данных можно подать в разделе «Показатели деятельности», содержащем формы заявки с исходными данными, нажав на ячейку с некорректным значением</li>-->
        <!--      <li>- апелляцию на ошибку в расчете значения показателя и (или) его нормированной оценки можно подать, нажав на оранжевый значок звездочки около значения количества баллов по показателю</li>-->
        <!--      <li>- апелляцию на ошибку в расчете сводной оценки заявки можно подать, нажав на оранжевый значок звездочки около значения сводной оценки заявки</li>-->
        <!--    </ul>-->
        <appeal-indicators
                ref="appeal-dialog"
                :appeal="appeal"
                :loading="laodingAppeals"
                :appeal-info="appealInfo"
                @saved-value="saveValue($event)"
                @closing-dialog="closingAppealDialog"
        ></appeal-indicators>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    import {mapGetters} from "vuex";
    import CardIndicator from "@/components/cards/indicatiors/cardIndicator";
    import {
        getAppeals,
        getKcpIndicatorsFull,
        getKcpIndicatorsSpr, /*getAllGroupedKcpIndicators*/
    } from "@/api/indicators";
    import AppealIndicators from "@/components/Dialogs/appeaIndicators";
    import {BiIndicators} from "@/pages/Organization/kcpBalls/biIndicators";

    export default {
        name: "fullInfo",
        components: {AppealIndicators, CardIndicator},
        data() {
            return {
                indicators: null,
                indicatorsList: [],
                loading: false,
                laodingAppeals: false,
                appealsArr: [],
                appeal: null,
                appealInfo: null,
                foList: [
                    {id: 1, text: 'очная', value: 'o'},
                    {id: 2, text: 'очно-заочная', value: 'v'},
                    {id: 3, text: 'заочная', value: 'z'},
                ],
                bIndicators: BiIndicators
            }
        },
        computed: {
            ...mapGetters('spr', {
                getUsls: 'getUsls',
                getUslsStatus: 'getUslsStatus',
                getIndicators: 'getIndicators',
                getIndicatorsStatus: 'getIndicatorsStatus',
                getMainOrg: 'getMainOrg',
                getOrgs: 'getOrgs',
            }),
            indicator() {
                return this.indicators != null ? {data: this.indicators, fo: this.idFO} : {data: null, fo: this.idFO}
            },
            idFO() {
                return this.$route.query.fo != null ? Number.parseInt(this.$route?.query.fo) : 1
            },
            foName() {
                return this.foList.find(el => el.id === this.idFO)
            },
            middleValue() {
                return this.$route.query.value != null ? Number.parseFloat(this.$route.query?.value) : null
            },
            idUsl() {
                return this.$route.query.usl != null ? Number.parseInt(this.$route?.query.usl) : 1
            },
            uslName() {
                return this.getUsls.find(el => el.id === this.idUsl)?.name ?? ''
            },
            codeName() {
                return this.$route.query.code ?? ''
            },
            kcpName() {
                return this.$route.query.name ?? ''
            },
            orgId() {
                return Number.parseInt(this.$route.query.org ?? null) ?? null;
            },
            kcpId() {
                return Number.parseInt(this.$route.query.kcpId ?? null) ?? null;
            },
            id() {
                return this.$route.query.id != null ? Number.parseInt(this.$route.query?.id) : null
            },
            defaultText() {
                return this.codeName + ' ' + this.kcpName + '. ' + this.uslName + ' - ' + this.foName?.text;
            },
            chosenOrg() {
                if (this.getMainOrg?.id === this.orgId) {
                    return this.getMainOrg
                } else if (this.getOrgs?.find(el => el.id === this.orgId)) {
                    return this.getOrgs?.find(el => el.id === this.orgId)
                } else return null;
            },
            nameOrgForRegion() {
                return this.indicators?.orgId?.name ?? ''
            },
            bIndicatorsCalculated() {
                // if (this.indicator.data != null)
                return this.bIndicators
                    .filter(el => el.idUsl === this.idUsl)
                    .map(el => {
                        const sprEl = this.indicatorsList?.data?.find(pok => pok.pid.toLowerCase() === el.dataFieldName);
                        console.log(sprEl.pid.toLowerCase() + 'wt', this.indicators[sprEl.pid.toLowerCase() + 'wt'], sprEl);
                        if (sprEl.pid)
                            return {
                                ...el,
                                // count: (Math.random() *100).toFixed(sprEl.prd),
                                count: sprEl.pid.toLowerCase() === 'b41' || sprEl.pid.toLowerCase() === 'm41' || sprEl.pid.toLowerCase() === 'o41' || sprEl.pid.toLowerCase() === 'a31' ? 'Показатель не рассчитывается' : (Number.parseInt(this.indicators[sprEl.pid.toLowerCase() + 'wt']) === 0 ? 'Показатель не рассчитывается для этой УГСН(НПС)' : this.$scripts.TableJs.checkValueWithNullAndReturnND(this.indicators[sprEl.pid.toLowerCase() + 'o' + this.foName?.value + ''], 3, 'float', true, 0)),
                                max: sprEl.pid.toLowerCase() === 'b25' && el.idUsl === 2 ? 60 : sprEl.pmx,
                                min: sprEl.pmi,
                                about: sprEl.pnm,
                                available: sprEl.pid.toLowerCase() === 'b41' || sprEl.pid.toLowerCase() === 'm41' || sprEl.pid.toLowerCase() === 'o41' || sprEl.pid.toLowerCase() === 'a31' ? false : Number.parseInt(this.indicators[sprEl.pid.toLowerCase() + 'wt']) !== 0,
                                ppr: sprEl.ppr,
                                ptx: sprEl.ptx,
                                maxGradient: this.indicators[sprEl.pid.toLowerCase() + 'wt'],
                                minGradient: 0,
                                prd: sprEl.prd
                            }
                        return {
                            ...el,
                            count: (Math.random() * 100).toFixed(3),//this.indicator.data[el.dataFieldName + 's0'] === '1' ? this.indicator.data[el.dataFieldName + this.idFO] :
                            //'Показатель не рассчитывается для этой УГСН(НПС)',
                            max: 100//this.indicator.data[el.dataFieldName + 'w']
                        }
                    })
                // else return []
            }
        },
        watch: {
            $route() {
                this.initHeader();
            },
            chosenOrg() {
                this.initHeader()
            }
        },
        created() {
            this.initHeader();
            this.loadingAppeals();
            this.getServerData();
        },
        methods: {
            async loadingAppeals() {
                this.laodingAppeals = true;
                const res = await getAppeals();
                this.appealsArr = res.filter(el => el.kcpGroup.id === this.kcpId && el.fo.id === this.idFO && el.usl.id === this.idUsl && el.org?.id === this.orgId);
                this.laodingAppeals = false;
            },
            async getServerData() {
                try {
                    this.loading = true;
                    this.indicatorsList = await getKcpIndicatorsSpr();
                    this.indicators = await getKcpIndicatorsFull(this.orgId, this.kcpId, this.idUsl, this.idFO)
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.error('getServerData ' + e)
                }
            },
            closingAppealDialog() {
                this.appeal = null;
                this.appealInfo = null;
            },
            async openAppeal(e) {
                this.appeal = this.appealsArr?.find(el => el.indicator === e.dataFieldName) ?? null;
                this.appealInfo = {
                    ...e,
                    usl: {id: this.idUsl},
                    fo: {id: this.idFO},
                    kcpGroup: {id: this.kcpId},
                    org: {id: this.orgId}
                };
                await this.$refs["appeal-dialog"].openDialog();
            },
            saveValue(e) {
                const ind = this.appealsArr.findIndex(el => el.indicator === e.indicator)
                if (ind === -1)
                    this.appealsArr.push(e);
                else this.appealsArr.splice(ind, 1, e)
                this.$refs["appeal-dialog"].closeDialog();
            },
            initHeader() {
                let org = '';
                if (this.chosenOrg)
                    org = `<span class="formul-text-table">${this.chosenOrg.name}</span>`;
                this.$route.meta.title = org + '<br/> ' + this.defaultText;
            }
        },
    }
</script>

<style scoped>
    .header-columns {
        font-weight: 500;
        font-size: 12px;
        line-height: 124.9%;
        /* identical to box height, or 15px */

        display: flex;
        align-items: center;
        letter-spacing: 0.01em;
        font-feature-settings: 'pnum' on, 'lnum' on;

        /* Anton Grey */
        border-bottom: 1px solid #78909C;
        color: #78909C;
    }
</style>